import React from "react";
import { Button } from "../../../components/ui/button";
import { Link } from "react-router-dom";
import { Mail, MessageSquare } from "lucide-react";

const TrialistContactPage = () => {
  return (
    <div className='min-h-screen bg-black text-white p-8'>
      <div className='max-w-3xl mx-auto'>
        <h1 className='text-4xl font-bold mb-8 text-green-500'>Contact Us</h1>

        <p className='text-lg text-gray-300 mb-12'>
          Have questions about Trialist or want to learn more about participating in
          research studies? We'd love to hear from you.
        </p>

        <div className='space-y-8'>
          <section className='bg-gray-900 rounded-lg p-6'>
            <div className='flex items-center gap-3 mb-4'>
              <Mail className='w-6 h-6 text-green-500' />
              <h2 className='text-2xl font-semibold'>Email Us</h2>
            </div>
            <p className='text-gray-300 mb-4'>
              For general inquiries, support, or feedback:
            </p>
            <a
              href='mailto:trialist@anyonelabs.com'
              className='text-green-500 hover:text-green-400 text-lg'
            >
              trialist@anyonelabs.com
            </a>
          </section>

          <section className='bg-gray-900 rounded-lg p-6'>
            <div className='flex items-center gap-3 mb-4'>
              <MessageSquare className='w-6 h-6 text-green-500' />
              <h2 className='text-2xl font-semibold'>For Researchers</h2>
            </div>
            <p className='text-gray-300 mb-4'>
              Interested in running your research study on Trialist? Get in touch with
              our research partnerships team:
            </p>
            <a
              href='mailto:research@anyonelabs.com'
              className='text-green-500 hover:text-green-400 text-lg'
            >
              research@anyonelabs.com
            </a>
          </section>
        </div>

        <div className='mt-12 flex gap-4'>
          <Link to='/trialist'>
            <Button variant='outline' className='text-green-500 border-green-500'>
              Back to Trialist
            </Button>
          </Link>
          <Link to='/'>
            <Button variant='outline' className='text-gray-400 border-gray-600'>
              Anyone Labs Home
            </Button>
          </Link>
        </div>
      </div>
    </div>
  );
};

export default TrialistContactPage;
